export default __webpack_public_path__ + "static/media/Mortiferous Tasset.9dd3743b.jpg";